// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { scale: require('./_math-scale') });



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es7.math.scale.js
// module id = 796
// module chunks = 0